<template>	
	<span class="relative">
	<Icon class="pointer" :type="type" :size="size" @click="copyText()" />
	<textarea ref="text"  v-model="value" style="position:absolute;width:0;height:0;opacity:0;z-index:-1"></textarea>
	</span>
</template>
<script>
export default {
	name: 'i-copy',
	props: {
		value: {
			type: [String, Number, Array],
			default: ''
		},
		type: {
			type: String,
			default:'md-copy'
		},
		size: {
			type: String,
			default:'18' 
		},
		msg: {
			type: String,
			default:'复制成功'
		}
	},
	data () {
		return {
			
		}
	},
	watch: {
		
	},
	mounted(){			
		
	},
	methods: {
		copyText(){
			this.$refs.text.select();
			document.execCommand("copy");
			this.$Message.success({content:this.msg,closable: true});
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/inc/dictionary/copy.vue